import { render, staticRenderFns } from "./homeKanBan.vue?vue&type=template&id=08d4e1ea&scoped=true&"
import script from "./homeKanBan.vue?vue&type=script&lang=js&"
export * from "./homeKanBan.vue?vue&type=script&lang=js&"
import style0 from "./homeKanBan.vue?vue&type=style&index=0&id=08d4e1ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4e1ea",
  null
  
)

export default component.exports